<template>
  <div class="cmsc-page-wrapper sccm-optimize sccm-list">
    <div class="cmsc-page-header">
      <Dropdown transfer>
        <h1 class="cmsc-page-title theme-border-primary-color">
          {{ tableView }}
          <Icon v-if="views.length > 1" type="md-arrow-dropdown" />
        </h1>
        <DropdownMenu slot="list" v-if="views.length > 1">
          <DropdownItem
            v-for="item in views"
            :name="item.value"
            :key="item.label"
            :selected="item.selected"
            @click.native="tableViewChange(item.value)"
          >{{ item.label }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <div v-if="businesses.length > 0">
        <Button @click="exportClientData()" class="mybtn" v-if="exportBtn">
          <!-- <CIcon icon="tongyong-daochu" size="14"></CIcon> -->
          导出
        </Button>
        <Dropdown
          transfer
          type="primary"
          :disabled="businesses.length === 0"
          v-if="newCustom"
          transfer-class-name="mytransfer"
        >
          <Button type="primary" ghost class="mybtn" style="border-radius:0 4px 4px 0;">
            新建
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem
              style="text-align:center;line-height: normal;padding: 7px 16px;"
              v-for="(item, index) in businesses"
              :key="item.sbtId"
              :name="item"
              @click.native="selectBusiness(item)"
            >{{item.sbtName}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Dropdown style="margin-left: 10px" type="primary" v-if="showCustomBtn">
          <Button type="primary">
            <Icon type="ios-arrow-down"></Icon>自定义按钮
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem
              style="text-align:center;line-height: normal;padding: 7px 16px;"
              v-for="(item, index) in customButtons"
              @click.native="commonMethod(item)"
              :key="index"
            >{{ item.btnName }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
    <div class="mtop">
      <formMix
        ref="mixForm"
        @change="searchFieldChange"
        :viewId="viewId"
        :viewType="viewType"
        :moId="objectId"
        v-if="viewId"
      />
      <div class="scmd-handle-div" v-show="handleDivCon">
        <Checkbox
          :indeterminate="indeterminate"
          :value="checkAll"
          @click.prevent.native="handleCheckAll"
        ></Checkbox>
        已选择【{{ selectCount }}】项
        <Button type="text" v-if="removeCustom" class="openOrCloseWork" @click="removeSome">删除</Button>
        <!-- <Button type="text" v-if="exportBtn" class="openOrCloseWork" @click="batchExport()">导出</Button> -->
      </div>
        <!-- @on-selection-change="savedata" -->
      <Table
        :row-key="true"
        id="tableBox"
        stripe
        ref="customTable"
        :columns="tableColumns"
        :data="tableData"
        :loading="searchLoading"
        @on-sort-change="sortHandClap"
      >
        <template slot-scope="{row,index}" slot="action" v-show="!viewCustom && !editCustom && !removeCustom">
          <CIcon
            icon="tongyong-chakan"
            @click="selectCurrentRow(row)"
            size="16"
            style="cursor:pointer;margin-right: 12px"
            v-if="viewCustom"
            class="icon_1"
          ></CIcon>
          <CIcon
            icon="tongyong-bianji"
            @click="editCustomLine(row)"
            style="cursor:pointer;margin-right: 12px"
            size="16"
            v-if="editCustom"
            class="icon_1"
          ></CIcon>
          <Poptip
            popper-class="kehu_tip"
            confirm
            transfer
            placement="top"
            title="你确定删除该问卷吗？"
            @on-ok="deleteCustom(row)"
          >
            <CIcon
              v-if="removeCustom"
              style="cursor:pointer;"
              icon="tongyong-shanchu"
              tip="删除"
              :delay="3000"
              hoverColor="#f74942"
              activeColor="#ba302c"
            />
          </Poptip>
        </template>
      </Table>
    </div>
    <!-- 分页 -->
    <div class="sccm-page">
      <Row>
        <Col span="24">
          <Page
            :total="total"
            :current="pageNum"
            :page-size="pageSize"
            show-elevator
            show-sizer
            show-total
            placement="top"
            @on-change="pageChange"
            @on-page-size-change="pageChangeSize"
          ></Page>
        </Col>
      </Row>
    </div>
    <!-- 新建编辑操作 -->
    <div>
      <Drawer
        v-model="editDrawerStatus"
        :title="titleName"
        width="556"
        :transfer="false"
        class="DrawerStyle newDraw"
      >
        <div class="drawer-content">
          <objectAddOrEdit
            v-if="editDrawerStatus"
            class="left"
            ref="objectAddOrEdit"
            :data="{isFlowType:currentBusiness.isFlowType,tenantId:tenantId,moId:objectId,rowId:currentBusiness.rowId,mtId:currentBusiness.mtId,busType:currentBusiness.sbtId,modelId:currentBusiness.flowModelId,isApprovePage:true}"
            @on-success="onEditSuccess"
          ></objectAddOrEdit>
        </div>

        <div class="cmsc-drawer-footer">
          <template>
            <Button class="handle-item" @click="editCancel">取消</Button>
            <Button class="handle-item" type="primary" @click="editSubmitData">保存</Button>
          </template>
        </div>
      </Drawer>
    </div>
    <!--视图控制-->
    <div>
      <Drawer
        title="列表设置"
        v-model="viewModal"
        :footer-hide="true"
        :mask-closable="false"
        @on-visible-change
        width="520"
      >
        <Form ref="viewForm" :model="viewForm" :label-width="80" style="padding:0 20px;">
          <h2 style="margin-bottom:10px;font-size:16px;">显示字段：</h2>
          <Transfer
            :data="data"
            :target-keys="targetKeys"
            :render-format="render"
            @on-change="handleChange"
            style="padding-bottom:50px;"
          ></Transfer>
          <FormItem class="btnPos">
            <Button @click="viewModal = false">取消</Button>
            <Button type="primary" @click="viewSubmit('viewForm')">保存</Button>
          </FormItem>
        </Form>
      </Drawer>
    </div>
    <!-- 导出 -->
    <Drawer
      title="选择导出的字段"
      v-model="orgExModal"
      width="600"
      :mask-closable="true"
      :styles="styles"
      @on-close="orgExModalCancel"
      class="export-model"
    >
      <Form :label-width="100" ref="exportFormData" :model="exportFormData">
        <FormItem>
          <Checkbox
            :indeterminate="indeterminate1"
            :value="checkAllColmus"
            @click.prevent.native="handleCheckAllColmus"
          >全选</Checkbox>
          <CheckboxGroup
            v-model="exportFormData.exportColums"
            class="checkBoxFlex"
            @on-change="checkAllGroupChange"
          >
            <Checkbox :label="item.fieldCname" :key="item.fieldCname" v-for="item in exportColumsList">
              <Tooltip transfer :content="item.fieldName">
                <span>{{item.fieldName.length>25?item.fieldName.substring(0,25)+'...':item.fieldName}}</span>
              </Tooltip>
            </Checkbox>
          </CheckboxGroup>
        </FormItem>
      </Form>
      <div class="export-footer">
        <Button class="btn-cancel" @click="orgExModalCancel">取消</Button>
        <Button type="primary" @click="exportSubmit()">导出</Button>
      </div>
    </Drawer>
    <Drawer v-model="showDetail" width="600" :title="editTitle" class="export-model" @on-close="closeDetail">
      <CQuestionnaire
      ref = 'question'
      v-if="showDetail"
      :moId = 'qsDetailQueryProps.moId'
      :mtId = 'qsDetailQueryProps.mtId'
      :busType = 'qsDetailQueryProps.busType'
      :tenantId = 'qsDetailQueryProps.tenantId'
      :isPreview = 'qsDetailQueryProps.isPreview'
      :isVertical = 'qsDetailQueryProps.isVertical'
    />
    <div class="export-footer" v-if="showDetailBtn">
        <Button class="btn-cancel" @click="closeDetail">取消</Button>
        <Button type="primary" @click="saveQsDetail">保存</Button>
      </div>
    </Drawer>
  </div>
</template>
<script>
import envConst from "@/env-const";
import { mConst } from "./mConst";
import { dynicMaxAndMinLength } from "./gllength";
import { dynicValMinength } from "./gllength";
import { dynicMaxInt } from "./gllength";
import { dynicMaxDouble } from "./gllength";
import { commonutils } from "./commonutils";
import Detail from "./qsDetil.vue"
import "./qsList.styl";
export default {
  name: "qsList",
  computed: {
    tenantId() {
      return this.$store.state.main.user.info.tenantId;
    }
  },
  watch: {
    views: {
      handler(newValue) {
        if (typeof newValue === "string") {
          this.tableView = newValue;
          this.tableViewOptions = [];
        } else {
          if (newValue.length > 0) {
            this.tableViewOptions = newValue;
            for (let i = 0; i < this.tableViewOptions.length; i++) {
              if (this.tableViewOptions[i].selected) {
                this.tableView = this.tableViewOptions[i].label;
                this.tableViewChange(this.tableViewOptions[i].value);
                this.searchExportColumns(this.tableViewOptions[i].value);
                return;
              }
            }
          } else {
            this.tableView = "";
            this.tableViewOptions = [];
          }
        }
      },
      immediate: true
    },
    tableData:{
      handler(n) {
        clearInterval(this.getWidthTimer);
        this.getWidthTimer = setInterval(() => {
          let maxWidth = document.querySelector("#tableBox").clientWidth;
          let tableWidth = document.querySelector("#tableBox table").clientWidth;
          if (tableWidth !== 1) {
            clearInterval(this.getWidthTimer);
            // console.log(123456, maxWidth, tableWidth);

            this.tableColumns = this.tableColumns.map(item => {
              if (tableWidth > maxWidth) {
                if (item.key === "action") {
                  item.fixed = "right";
                }
                if (item.type === "selection") {
                  item.fixed = "left";
                }
              }else {
                if((item.key === "action")|| (item.type === "selection")) {
                  delete item.fixed
                }
              }

              return item;
            });
          }
        }, 500);
      },
      deep:true
    }
  },
  data() {
    return {
      getWidthTimer: null,
      qsDetailQueryProps: {},
      showDetail: false,
      editTitle: "问卷详请",
      showDetailBtn: false,
      callIcon: false,
      viewId: "",
      viewType: "",
      rowId: null,
      searchLoading: false,
      isFlowType: "0",
      loginUserInfo: {},
      views: [],
      tableColumns: [],
      tableFlowColumns: [
        {
          title: "主属性名称",
          key: "main_pro_name"
        },
        {
          title: "业务类型",
          key: "business_type"
        },
        {
          title: "状态",
          key: "state"
        },
        {
          title: "是否超时",
          key: "overtime"
        },
        {
          title: "创建人",
          key: "create_by"
        },
        {
          title: "创建日期",
          key: "create_date"
        },
        {
          title: "操作",
          width: 100,
          slot: "flowAction"
        }
      ],
      processComments: [],
      tableData: [],
      editDrawerStatus: false,
      handleDrawerStatus: false,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      flowHandleButtons: [],
      customColumnData: {
        OBJECT_NAME: "",
        value: {}
      },
      //默认操作表明配
      MAIN_OBJECT_NAME: "scmd_ask_info_"+JSON.parse(localStorage.user).info.tenantId,
      //查询视图所需moId
      resourceTname: {
        objectTname: "", //表名
        objectState: "" //可用状态
      },
      objectId: "",
      tableView: "",
      tableViewOptions: [],
      handleDivCon: false, //多选每行时展示已选择多少条数
      checkAll: false,
      indeterminate: true,
      getSelectionCustoms: [], //勾选中的客户资料数据
      newCustom: false, //新建按钮是否显示
      exportBtn: false, //导出按钮是否显示
      showCustomBtn: false, //自定义按钮的是否显示
      editCustom: false, //编辑按钮是否显示
      removeCustom: false, //删除按钮是否显示
      viewCustom: false, //查看按钮是否显示
      businesses: [], //业务类型列表
      businessesEdit: [],
      customButtons: [], //按钮集合
      //操作项
      actionOptions: {},
      selectCount: "",
      currentBusiness: {}, //点击新增时传值
      viewModal: false,
      viewForm: {
        moId: null,
        fieldIds: null,
        viewId: ""
      },
      data: [],
      dataTransfer: [],
      targetKeys: [],
      checkedViewItem: {},
      fieldIds: "",
      selectActionData: {
        Head: { method: "select", version: "1.0" },
        Data: [
          {
            OBJECT_NAME: "scmd_ask_info_"+JSON.parse(localStorage.user).info.tenantId,
            whereOf: " ",
            columns: "*",
            moId: "",
            page: { pageNumber: 1, pageSize: 20 },
            orderBy: " "
          }
        ]
      },
      searchWhereOf: {},
      queryParmaeters: {
        selectActionData: {}
      },
      orgExModal: false,
    
      imbusType: "",
      exportFieldList: [],
      exportColumsList: [],
      indeterminate1: false,
      checkAllColmus: false,
      exportFormData: {
        exportColums: []
      },
      resourceData: {
        moId: ""
      },
      OBJECT_NAME: "",
     
      dymaticKeyList: [],
      version: mConst.custom.version,
      selectType: mConst.custom.type.selectType,
      fieldTypeObjectParam: mConst.fieldTypeObjectParam, //引用字段
      handleUuId: "",
      queryUrl:
        envConst.SCMD_API_BASE + "/scmd/fields/getFieldAndDataListByViewId",
      currentData: [],
      itsPropertiesMain: mConst.itsPropertiesMain,
      itsPropertiesObject: mConst.itsPropertiesObject,
      itsPropertiesSystem: mConst.itsPropertiesSystem,
    };
  },
  mounted() {
    this.getUserInfoFromSession();
    this.searchViewByTableName();
  },
  methods: {
    // 获取导出字段
    getExportColumsList(moId){
      this.$http
        .get(envConst.SCMD_API_BASE + "/scmd/fields/getObjectFieldListByMoId", {
          params: {
            moId: moId,
            usePermission: 'use'
          }
        })
        .then(response => {
          if (response.data.returnCode === 0) {
            console.log("获取导出字段",response.data)
            this.exportColumsList = response.data.beans;
          } else {
            this.exportColumsList = [];
          }
        });
    },
    // 详情抽屉状态关闭
    closeDetail() {
      this.showDetail = false;
      this.showDetailBtn = false;
    },
    sortHandClap({ column, order }) {
      //  debugger;
      this.orderBy = `${column.key} ${order}`;
      this.getTableData(`${column.key} ${order}`);
    },
    // 编辑器取消
    editCancel() {
      this.$refs["objectAddOrEdit"].cancel();
      this.editDrawerStatus = false;
    },
    editSubmitData() {
      this.$refs["objectAddOrEdit"]
        .getFormData("customFormData")
        .then(customFiled => {
          console.log("11", customFiled);
          this.editSubmitDataSure(customFiled);
        });
    },
    //编辑器提交
    editSubmitDataSure(customFiled) {
      if (customFiled.returnCode === "0") {
        var columnObj = customFiled.values;
        //this.$set(columnObj,'tenant_id',this.loginUserInfo.tenantId)
        columnObj["tenant_id"] = this.loginUserInfo.tenantId;
        columnObj["business_type"] = this.currentBusiness.sbtId;
        columnObj["create_by"] = this.loginUserInfo.userId;
        columnObj["state"] = "1";
        if (this.method == "update") {
          columnObj["whereOf"] = { mt_id: this.currentBusiness.mtId };
        }
        var params = {
          Head: {
            moId: this.objectId,
            method: this.method,
            version: "v1.0"
          },
          Data: [
            {
              state: "1",
              moId: this.objectId,
              OBJECT_NAME: customFiled.OBJECT_NAME,
              modelId: this.currentBusiness.flowModelId,
              approveTaskDate: {},
              value: columnObj
            }
          ]
        };
        this.$http
          .post(
            `${envConst.SCMD_API_BASE}/scmd/dynObject/operObjectCheck`,
            params
          )
          .then(response => {
            if (response.data.returnCode == 0) {
              if (!response.data.bean.checkCode) {
                this.$Message.error(response.data.bean.errMsg);
              } else {
                this.$Message.success("保存成功");
                this.onEditSuccess();
              }
            } else {
              this.$Message.error(response.data.returnMessage);
            }
          });
      }
    },

    // 调用mconst后的回调方法
    callbackSearchReturnData: function(resData) {
      if (resData.returnCode === this.returnCodeValid) {
        this.returnData = resData.beans;
        this.pageTotal = parseInt(resData.bean.total);
      } else {
        this.$Message.error("数据查询失败!");
        this.returnData = [];
      }
      this.searchLoading = false;
    },
    // 编辑保存成功
    onEditSuccess() {
      this.editDrawerStatus = false;
      this.handleCheckAll()
      this.getTableData();
    },
    // 选择业务类型
    selectBusiness(currentBusiness) {
      this.method = "insert";
      this.titleName = "新增";
      this.flowState = "";
      this.currentBusiness.flowModelId = "";
      //this.currentBusiness.sbtId = currentBusiness.sbtId;
      this.currentBusiness = currentBusiness;
      this.currentBusiness.mtId = "";
      this.currentBusiness.rowId = "";
      this.currentBusiness.ctype = "";
      this.currentBusiness.modelId = "";
      this.currentBusiness.taskId = "";
      this.editDrawerStatus = true;
    },

    // 批量删除提示
    removeSome() {
      this.$Modal.confirm({
        title: "确认操作",
        content:
          "<p>是否确认对已选问卷进行<span style='color:red;'> [删除] </span>操作？</p>",
        onOk: () => {
          this.batchDelete();
        }
      });
    },
    //点击批量删除按钮
    batchDelete: function() {
      // console.log(this.getSelectionCustoms);
      if (this.getSelectionCustoms.length < 1) {
        this.$Message.error("请先选中要执行的操作列");
      } else {
        // var delTip = confirm("确认执行批量删除");
        var delTip = true;
        if (delTip == true) {
          for (let i = 0; i < this.getSelectionCustoms.length; i++) {
            this.$http
              .get(
                envConst.SCMD_API_BASE +
                  "/scmd/dynObject/deleteDataByMtId?moId=" +
                  this.objectId +
                  "&mtId=" +
                  this.getSelectionCustoms[i].mt_id
              )
              .then(response => {
                if (response.data.returnCode === 0) {
                  if (i == this.getSelectionCustoms.length - 1) {
                    this.$Message.success("删除成功");
                    this.handleCheckAll(); //取消选中效果
                    this.getTableData();
                  }
                }
              });
          }
        }
      }
    },
    //点击批量导出按钮
    batchExport: function() {
      this.exportClientData();
    },
    //点击单个删除按钮
    deleteCustom: function(row) {
      if (
        this.loginUserInfo.userType != "1" &&
        this.loginUserInfo.userType != "2"
      ) {
        if (this.businessesEdit.length == 0) {
          this.$Message.warning("无权限操作当前业务类型数据");
          return;
        } else {
          let flag = false;
          for (let i = 0; i < this.businessesEdit.length; i++) {
            if (row.business_type_id == this.businessesEdit[i].sbtId) {
              flag = true;
            }
          }
          if (!flag) {
            this.$Message.warning("无权限操作当前业务类型数据");
            return;
          }
        }
      }
      // var delTip = confirm("确认删除");
      var delTip = true;
      if (delTip == true) {
        this.$http
          .get(
            envConst.SCMD_API_BASE +
              "/scmd/dynObject/deleteDataByMtId?moId=" +
              this.objectId +
              "&mtId=" +
              row.mt_id
          )
          .then(response => {
            if (response.data.returnCode === 0) {
              this.$Message.success("删除成功");
              this.handleCheckAll(); //取消选中效果
              this.getTableData();
            }
          });
      }
    },
    //点击进入详情页
    selectCurrentRow(row) {
      // console.log("row==",row)
      this.qsDetailQueryProps = {};
      this.qsDetailQueryProps = {
        moId: this.objectId,
        mtId: row.mt_id,
        busType: row.business_type_id,
        tenantId: this.loginUserInfo.tenantId,
        isPreview: true,
        isVertical: true
      };
      this.editTitle = "问卷详情";
      this.showDetailBtn = false;
      this.showDetail = true;
    },
    //点击编辑功能
    editCustomLine(row) {
      if (
        this.loginUserInfo.userType != "1" &&
        this.loginUserInfo.userType != "2"
      ) {
        if (this.businessesEdit.length == 0) {
          this.$Message.warning("无权限操作当前业务类型数据");
          return;
        } else {
          let flag = false;
          for (let i = 0; i < this.businessesEdit.length; i++) {
            if (row.business_type_id == this.businessesEdit[i].sbtId) {
              flag = true;
            }
          }
          if (!flag) {
            this.$Message.warning("无权限操作当前业务类型数据");
            return;
          }
        }
      }
      this.qsDetailQueryProps = {};
      this.qsDetailQueryProps = {
        moId: this.objectId,
        mtId: row.mt_id,
        busType: row.business_type_id,
        tenantId: this.loginUserInfo.tenantId,
        isVertical: true
      };
      this.editTitle = "编辑问卷";
      this.showDetailBtn = true;
      this.showDetail = true;
    },
    //保存问卷
    saveQsDetail(){
      let _p = this.$refs['question']._save()
      if(_p){
        _p.then(()=>{
          this.$Message.success('保存成功');
          this.closeDetail();
          this.getTableData();
          this.qsDetailQueryProps = {};
        }).catch(()=>{
          this.$Message.error('问卷保存失败')
        })
      }
    },
    //取消全选
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      if (this.checkAll) {
        this.$refs.customTable.selectAll(true);
      } else {
        this.$refs.customTable.selectAll(false);
      }
    },
    //多行勾选时
    savedata(selectDate) {
      this.getSelectionCustoms = this.$refs.customTable.getSelection();
      console.log(this.getSelectionCustoms,"查看选中")
      if (selectDate.length > 0) {
        this.handleDivCon = true;
        if (this.total < this.pageSize) {
          if (this.total === selectDate.length) {
            this.checkAll = true;
            this.indeterminate = false;
          } else {
            this.checkAll = false;
            this.indeterminate = true;
          }
        } else {
          // console.log(this.total);
          if (selectDate.length === this.pageSize) {
            this.checkAll = true;
            this.indeterminate = false;
          } else {
            this.checkAll = false;
            this.indeterminate = true;
          }
        }
      } else {
        this.handleDivCon = false;
      }
      this.selectCount = selectDate.length;
    },
    //判定按钮方法
    commonMethod(btnItem) {
      //0打开新页面，1在当前页弹出，2执行JS
      if (btnItem.btnClickBehavior === "0") {
        let jumpUrl = btnItem.btnBehaviorContent;
        location.href = jumpUrl;
      } else if (btnItem.btnClickBehavior === "1") {
        window.open(btnItem.btnBehaviorContent);
      }
    },
    //切换视图
    tableViewChange(viewId) {
      this.tableViewOptions.forEach(item => {
        item.selected = false;
      });
      let target = this.tableViewOptions.find(item => item.value === viewId);
      this.tableView = target.label;
      target.selected = true;

      for (let i = 0; i < this.tableViewOptions.length; i++) {
        if (viewId == this.tableViewOptions[i].value) {
          this.tableView = this.tableViewOptions[i].label;
        }
      }
      this.viewId = viewId;
      this.pageNum = 1; //切换视图则默认第一页
      this.viewType = "view";
      this.$refs["mixForm"] &&
        this.$refs["mixForm"]._resetSync(
          this.viewId,
          this.viewType,
          this.objectId
        );
      this.getTableData();
      this.getLayOutBtn();
    },
    //1.从session获取登陆人信息
    getUserInfoFromSession: function() {
      let userInfo = JSON.parse(window.localStorage.user);
      this.loginUserInfo = userInfo.info;
    },
    //2.根据物理标名查mo_id
    searchViewByTableName() {
      this.resourceTname.objectTname = this.MAIN_OBJECT_NAME;
      this.resourceTname.objectState = mConst.custom.objectState;
      this.$http
        .get(envConst.SCMD_API_BASE + "/scmd/Object/baseGetObject", {
          params: this.resourceTname
        })
        .then(response => {
          if (response.data.returnCode === 0) {
            this.$nextTick(function() {
              if (response.data.beans.length > 0) {
                this.objectId = response.data.beans[0].moId;
                this.getViewsAndBusinessTypeByObjectId(this.objectId); //查询视图下拉选和字段
                this.getfieldMainProperty(this.objectId); //查询对象字段和主属性
                this.getExportColumsList(this.objectId);
              } else {
                this.$Message.warning("获取问卷对象失败");
              }
            });
          } else {
            this.objectId = "";
          }
        });
    },
    //3.获取视图和业务列表
    getViewsAndBusinessTypeByObjectId(objectId) {
      this.$http
        .get(
          `${envConst.SCMD_API_BASE}/scmd/Object/getCustomObjectView?moId=` +
            objectId
        )
        .then(({ data }) => {
          if (data.bean.viewList) {
            this.views = data.bean.viewList.map((item, index) => {
              return {
                label: item.viewName,
                value: item.viewId,
                type: item.type,
                selected: !index
              };
            });
            if (
              this.loginUserInfo.userType != "1" &&
              this.loginUserInfo.userType != "2"
            ) {
              if (this.views.length <= 0) {
                this.$Message.warning("无当前对象视图权限，请联系管理员");
                this.tableColumns = [];
                return;
              }
            }
          } else {
            this.views = [];
            this.tableColumns = [];
            this.tableData = [];
          }
          if (data.bean.BusinessTypeList) {
            this.businessesEdit = [];
            if (
              this.loginUserInfo.userType != "1" &&
              this.loginUserInfo.userType != "2"
            ) {
              this.businesses = data.bean.BusinessTypeList.filter(item => {
                return item.isNew == 1;
              });
              this.businessesEdit = data.bean.BusinessTypeList.filter(item => {
                return item.isOperate == 1;
              });
            } else {
              this.businesses = data.bean.BusinessTypeList;
              // console.log(data.bean.BusinessTypeList);
            }
          } else {
            this.businesses = [];
            this.tableColumns = [];
            this.tableData = [];
            this.businessesEdit = [];
          }
        });
    },
    //4.查询对象字段和主属性
    getfieldMainProperty(moId) {
      this.$http
        .get(envConst.SCMD_API_BASE + "/scmd/fields/getList", {
          params: { moId: moId, itsProperties: "0" }
        })
        .then(response => {
          if (response.data.returnCode === 0) {
            let objTable = response.data.beans[0];
            let obj = {
              title: objTable.fieldName,
              key: objTable.fieldCname
            };
            Object.assign(this.tableFlowColumns[0], obj);
          } else {
            this.$Message.error("数据查询失败!");
          }
        });
    },
    searchFieldChange(params) {
      //筛选事件

      console.log("筛选事件-》", params);
      this.orderBy = "";
      this.pageChange(1);
    },

    // 根据表头条件查询
    searchByTableHeard: function() {
      this.searchLoading = true;
      mConst.executeSearch(this);
    },

    _makeQuerySql(params) {
      let str = "";
      let num = "";
      for (let i in params) {
        if (params[i].value || params[i].value === 0) {
          if (
            params[i].fieldType == "5" ||
            params[i].fieldType == "6" ||
            params[i].fieldType == "7" ||
            params[i].calcResultType == "6" ||
            params[i].calcResultType == "7"
          ) {
            num = `${num} & ${i} between ${params[i].value["min"]} and ${params[i].value["max"]}`;
          } else if (params[i].fieldType == "10") {
            str = `${str} and ${i} = ${params[i].value}`;
          } else {
            str = `${str} and ${i} like ${params[i].value}`;
          }
        }
      }
      let pam = "";
      if (num === "") {
        pam = str;
      } else {
        pam = str + "$" + num;
      }
      return pam;
    },
    searchExportColumns(viewId) {
      if (!viewId) {
        return;
      }
      this.$http
        .get(
          envConst.SCMD_API_BASE +
            "/scmd/fields/getFieldAndDataListByViewId?viewId=" +
            viewId
        )
        .then(response => {
          if (response.data.returnCode === 0) {
            let fieldList = response.data.bean.fieldList;
            // console.log(fieldList);
            if (!response.data.bean.mtIdShow) {
              let fieldCname = "mt_id";
              fieldList = fieldList.filter(obj => {
                return fieldCname !== obj.fieldCname;
              });
            }
            if (!response.data.bean.businessTypeShow) {
              let fieldCname = "business_type";
              fieldList = fieldList.filter(obj => {
                return fieldCname !== obj.fieldCname;
              });
            }
            fieldList = fieldList.filter(obj => {
              return "15" !== obj.fieldType;
            });
            this.exportFieldList = fieldList;
            this.searchLoading = false;
          } else {
            this.$Message.error("查询失败!");
          }
        });
    },

    //5.获取表格数据
    getTableData() {
      if (!this.viewId) {
        return;
      }
      this.searchLoading = true;
      let params = {
        viewId: this.viewId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };

      if (this.orderBy) {
        params.orderBy = this.orderBy;
      }
      if (this.$refs["mixForm"]) {
        //let whereParam = this._makeQuerySql(this.$refs["mixForm"].formDatas);
        let whereParam = this.$refs["mixForm"]._makeQuerySql(
          this.$refs["mixForm"].formDatas
        );
        if (whereParam.indexOf("$") != -1) {
          let whereArr = whereParam.split("$");
          params.whereOf = whereArr[0];
          params.whereOfNum = whereArr[1];
        } else {
          params.whereOf = whereParam;
          params.whereOfNum = "";
        }
      }
      if (this.viewType === "view") {
        this.$http
          .get(
            `${envConst.SCMD_API_BASE}/scmd/fields/getFieldAndDataListByViewId`,
            {
              params
            }
          )
          .then(({ data }) => {
            this.searchLoading = false;
            // 表头字段处理
            var newArr = data.bean.fieldList;
            if (!data.bean.mtIdShow) {
              var fieldCname = "mt_id";
              newArr = newArr.filter(function(obj) {
                return fieldCname !== obj.fieldCname;
              });
            }
            if (!data.bean.businessTypeShow) {
              var fieldCname = "business_type";
              newArr = newArr.filter(function(obj) {
                return fieldCname !== obj.fieldCname;
              });
            }
            // this.checkedViewItem = newArr; //视图对应的字段ids
            let loginUser = JSON.parse(localStorage.getItem("user")).info;
            let channels = loginUser.configMapParams.channelTypes;
            // 账号类型为客服
            if (loginUser.userType == "4") {
              //技能组不为空，并且渠道里面有语音或者视频才会展示电话条
              if (
                loginUser.configMapParams.skillTypes != "" &&
                (channels.indexOf("1") !== -1 || channels.indexOf("8") !== -1)
              ) {
                this.callIcon = true;
              }
            }
            console.log("进入-->");
            let options = [];
            newArr.map(item => {
              if (item.fieldType == "15") {
                for (let i = 0; i < data.bean.dataList.list.length; i++) {
                  data.bean.dataList.list[i]._rowIndex =
                    i + this.pageNum * this.pageSize - this.pageSize; //这里添加该数据的序号
                }
              }
            });

            newArr.forEach((item, index) => {
              if (item.fieldType == 8) {
                options.push({
                  title: item.fieldName,
                  key: item.fieldCname,
                  minWidth: 150,
                  tooltip: true,
                  ellipsis: true,
                  sortable: item.isSort == "0" ? false : "custom",
                  render: (h, params) => {
                    if(params.row[item.fieldCname] === "--") {
                      return h('div','--')
                    }
                    if (params.row[item.fieldCname] == "" || !this.callIcon) {
                      return h(
                        "div",
                        this.$utils.filterSens(params.row[item.fieldCname])
                      );
                    } else {
                      return h("div", [
                        h(
                          "span",
                          {
                            style: {
                              marginRight: "5px"
                            },
                            class: {
                              fenpeiicon: true
                            }
                          },
                          this.$utils.filterSens(params.row[item.fieldCname])
                        ),
                      ]);
                    }
                  },
                  renderHeader: (h, params) => {
                    return h("span", [
                      h(
                        "Tooltip",
                        {
                          props: {
                            placement: "top-start",
                            content: params.column.title,
                            transfer: true,
                            maxWidth: "220"
                          }
                        },
                        [
                          h(
                            "span",
                            params.column.title.length > 5
                              ? params.column.title.substring(0, 5) + "..."
                              : params.column.title
                          )
                        ]
                      )
                    ]);
                  }
                });
              } else if (item.fieldType === mConst.fieldTypePhoto) {
                options.push({
                  title: item.fieldName,
                  key: item.fieldCname,
                  sortable: item.isSort == "0" ? false : "custom",
                  minWidth: 150,
                  renderHeader: (h, params) => {
                    return h("span", [
                      h(
                        "Tooltip",
                        {
                          props: {
                            placement: "top-start",
                            content: params.column.title,
                            transfer: true,
                            maxWidth: "220"
                          }
                        },
                        [
                          h(
                            "span",
                            params.column.title.length > 5
                              ? params.column.title.substring(0, 5) + "..."
                              : params.column.title
                          )
                        ]
                      )
                    ]);
                  },
                  render: (h, { row }) => {
                    let _img = row[item.fieldCname];
                    if (_img && _img !== '--') {
                      let imgs = new Array(); //组装成 数组
                      let imgUrls = new Array(); //组装成 数组
                      //imgs = _img.split(",");
                      imgs.push(_img.split(",")[0]);
                      for (let i = 0; i < imgs.length; i++) {
                        if (imgs[i]) {
                          let url =
                            envConst.API_BASE +
                            `/file/filemanage/downloadFileByIdAndName/${
                              imgs[i]
                            }?renameFileName=${new Date().getTime()}-${row._rowIndex +
                              1}-${index + 1}-${i + 1}`;
                          imgUrls.push(url);
                        }
                      }
                      return imgUrls.map(img => {
                        return h("CImgPreview", {
                          attrs: {
                            src: img,
                            style: "width: 45px;height: 45px;"
                          }
                        });
                      });
                    } else {
                      return h("span", "--");
                    }
                  }
                });
              } else {
                options.push({
                  title: item.fieldName,
                  key: item.fieldCname,
                  minWidth: 150,
                  tooltip: true,
                  sortable: item.isSort == "0" ? false : "custom",
                  renderHeader: (h, params) => {
                    return h("span", [
                      h(
                        "Tooltip",
                        {
                          props: {
                            placement: "top-start",
                            content: params.column.title,
                            transfer: true,
                            maxWidth: "220"
                          }
                        },
                        [
                          h(
                            "span",
                            params.column.title.length > 5
                              ? params.column.title.substring(0, 5) + "..."
                              : params.column.title
                          )
                        ]
                      )
                    ]);
                  },
                  render: (h,params)=>{
                      if(params.row[item.fieldCname] && params.row[item.fieldCname].length>5 && item.fieldType!="10" && item.fieldType!="8"){
                        let _val = ""
                        if(item.fieldType=="14"){
                          const getIndex = (str,strpram,index) => {
                            var strValue=str;
                            var strValue1="";
                            var value=0;
                            for(var i =0;i < index;i++){
                            strValue1 = strValue.substring(0,strValue.indexOf(strpram));
                            strValue = strValue.substring(strValue1.length+1);
                            value += (strValue1.length+1);
                            }
                            return value;
                          }
                          let _val14 = params.row[item.fieldCname]
                          let _i = getIndex(_val14,"/",3)
                          let _val141 = _val14
                          _val141 = _val141.substring(0,_i-1).split("/")
                          let _val142 = _val14.substring(_i,_val14.length)
                          // console.log(_val141)
                          _val = _val141.join("")+_val142
                        }
                        return h('span', [
                            h('Tooltip', {
                              props: {
                              placement: "top-start",
                                content: item.fieldType=="14"?_val:params.row[item.fieldCname],
                                transfer: true,
                                maxWidth: '220'
                              }
                            }, [
                              h('span', (item.fieldType=="14"?_val:params.row[item.fieldCname]).substring(0,5)+"...")
                            ]),
                          ])
                      }else{
                        return h('span', params.row[item.fieldCname]?params.row[item.fieldCname]:"--")
                      }
                    }

                });
              }
            });

            let tempArr = newArr.filter(item => {
              return item.fieldType !== "15";
            });

            this.actionOptions = {
              key: "action",
              title: "操作",
              align: "left",
              // fixed: "right",
              minWidth: 150,
              slot: "action",
              renderHeader: (h, params) => {
                return h("div", [
                  h("span", {
                    domProps: {
                      innerHTML: "操作"
                    }
                  }),
                ]);
              }
            };
            if(this.viewCustom || this.editCustom || this.removeCustom){
              options.push(this.actionOptions);
            }
            this.tableColumns = options;
            // 表单数据处理
            this.checkedViewItem = newArr; //视图对应的字段ids
            this.updatePaging(data.bean.dataList);
            // console.log(888,data.bean.dataList.list)
            data.bean.dataList.list = data.bean.dataList.list.map(item => {
              for (let k in item) {
                // if(k==='create_by'){ // 在这可能有tel_number
                //   item[k] = item[k+"_id"]
                // }
                if (item[k] === "") {
                  item[k] = "--";
                }
              }
              
              return item;
            });
            this.tableData = data.bean.dataList.list;
          });
      }
    },
    // 列表页拨打电话
    doCall(num) {
      let phoneJson = {
        calledDigits: num,
        taskId: "",
        taskCallType: ""
      };
      window.softPhoneApi.taskCallOut(phoneJson);
    },
    // 修改页码
    pageChange(pageNum) {
      this.updatePaging({ pageNum });
      this.getTableData();
    },
    pageChangeSize(pageSize) {
      this.updatePaging({ pageSize });
      if (this.pageNum == 1) {
        this.getTableData();
      }
    },
    // 改变视图
    //                viewChange(view) {
    //                    this.viewId = view.value
    //                    this.viewType = view.type;
    //                    this.getTableData()
    //
    //                },

    // 更新分页信息
    updatePaging({ pageNum, pageSize, total }) {
      pageNum && (this.pageNum = pageNum);
      pageSize && (this.pageSize = pageSize);
      this.total = total || 0;
    },
    //查询视图列表页面按钮
    getLayOutBtn() {
      this.$http
        .get(`${envConst.SCMD_API_BASE}/scmd/listLayout/getLayOutBtn`, {
          params: {
            moId: this.objectId,
            layoutType: 1, //布局类型，0详情、1列表
            usePermission: "use"
          }
        })
        .then(({ data }) => {
          if (data.returnCode == mConst.returnCodeValid) {
            this.customButtons = [];
            // this.checkedViewItem = data.bean.layOutBtn.;//视图对应的字段ids
            //this.fieldIds = data.bean.layOut.viewIds;//视图对应的字段ids
            let layOutBtn = data.bean.layOutBtn;
            if (layOutBtn.length === 0) {
              this.newCustom = false; //新建
              this.exportBtn = false; //导出
              this.removeCustom = false; //删除
              this.editCustom = false; //编辑
              this.viewCustom = false; //查看
            } else {
              let isShowNew = 0;
              let isShowExport = 0;
              let isShowRemove = 0;
              let isShowEdit = 0;
              let isShowView = 0;
              for (let i = 0; i < layOutBtn.length; i++) {
                if (layOutBtn[i].btnCode === "add") {
                  isShowNew += 1;
                }
                if (layOutBtn[i].btnCode === "export") {
                  isShowExport += 1;
                }
                if (layOutBtn[i].btnCode === "remove") {
                  isShowRemove += 1;
                }
                if (layOutBtn[i].btnCode === "edit") {
                  isShowEdit += 1;
                }
                if (layOutBtn[i].btnCode === "view") {
                  isShowView += 1;
                }
                //1自定义按钮 0 默认按钮
                if (layOutBtn[i].btnSysType === "1") {
                  this.customButtons.push(layOutBtn[i]);
                }
              }
              // 问卷列表 没有新建
              // if (isShowNew > 0) {
              //   this.newCustom = true;
              // } else {
              //   this.newCustom = false;
              // }

              if (isShowExport > 0) {
                this.exportBtn = true;
              } else {
                this.exportBtn = false;
              }
              if (isShowRemove > 0) {
                this.removeCustom = true;
              } else {
                this.removeCustom = false;
              }
              if (isShowView > 0) {
                this.viewCustom = true;
              } else {
                this.viewCustom = false;
              }
              if (isShowEdit > 0) {
                this.editCustom = true;
              } else {
                this.editCustom = false;
              }
              if (this.customButtons.length > 0) {
                this.showCustomBtn = true;
              } else {
                this.showCustomBtn = false;
              }
            }
          }
        });
    },

    //穿梭框数据
    handleChange(newTargetKeys, direction, moveKeys) {
      this.targetKeys = newTargetKeys;
    },
    //点击修改视图
    editView() {
      this.viewModal = true;
      // this.viewForm = JSON.parse(JSON.stringify(this.checkedViewItem));
      //加载穿梭框左侧数据
      this.getMockData();
      //加载穿梭框右侧数据
      this.getTargetKeys(this.checkedViewItem);
    },
    //获取字段穿梭框选中数据
    getTargetKeys(ids) {
      let mockData = [];
      for (let i = 0; i < this.checkedViewItem.length; i++) {
        if (
          this.checkedViewItem[i].fieldType != mConst.fieldTypePhoto &&
          this.checkedViewItem[i].fieldType != mConst.fieldTypeObject &&
          this.checkedViewItem[i].fieldType != mConst.fieldTypeMainChild
        ) {
          mockData.push(this.checkedViewItem[i].mofId);
        }
      }
      this.targetKeys = mockData;
    },
    //穿梭框展示数据
    render(item) {
      return item.label;
    },
    //获取字段穿梭框数据
    getMockData() {
      let mockData = [];
      let moId = this.objectId;
      this.$http
        .get(
          envConst.SCMD_API_BASE +
            "/scmd/fields/getPermissionFieldList?moId=" +
            moId +
            "&fieldState=1"
        )
        .then(response => {
          if (response.data.returnCode === 0) {
            let result = response.data.beans;
            //把请求到的字段list赋值给两个下拉框
            // this.selectFieldList = result;
            for (let i = 0; i < result.length; i++) {
              if (
                result[i].fieldType != mConst.fieldTypePhoto &&
                result[i].fieldType != mConst.fieldTypeObject &&
                result[i].fieldType != mConst.fieldTypeMainChild
              ) {
                mockData.push({
                  key: result[i].mofId,
                  label: result[i].fieldName
                });
              }
            }
            this.data = mockData;
            this.dataTransfer = mockData;
          } else {
            this.$Message.error("获取数据异常!");
          }
        });
    },
    // 弹出框取消关闭
    viewCacel() {
      this.viewModal = false;
    },
    //列表视图修改提交
    viewSubmit(name) {
      this.viewForm.moId = this.objectId;
      let keyStr = "";
      for (let i = 0; i < this.targetKeys.length; i++) {
        keyStr += this.targetKeys[i] + ",";
      }
      if (keyStr === "") {
        this.$Message.warning("目的列表显示字段不能为空");
        return;
      }
      var qs = require("qs");
      var self = this;
      self.viewForm.fieldIds = keyStr;
      self.viewForm.viewId = self.viewId;
      this.$http
        .put(
          envConst.SCMD_API_BASE +
            "/sccm/listView/updateRowById?" +
            qs.stringify(self.viewForm)
        )
        .then(function(data) {
          if (data.data.returnCode === 0) {
            // 获取需要渲染到页面中的数据
            self.$Message.success("修改成功!");
            self.viewModal = false;
            self.fieldIds = self.viewForm.fieldIds;
            self.getTableData();
            self.handleDivCon = false
          } else {
            self.$Message.success("修改失败!");
          }
          
        });
    },
    exportClientData() {
      this.orgExModal = true;
    },
    orgExModalCancel() {
      this.indeterminate1 = false;
      this.checkAllColmus = false;
      this.exportFormData.exportColums = [];
      this.orgExModal = false;
    },
    exportSubmit() {
      let operFields = this.exportFormData.exportColums.join(",");
      // 调用选中导出或默认导出接口
      let params = {
        orderString: {
          selectActionData: {
            Head: {
              method: "select",
              version: "v1.0"
            },
            Data: [
              {
                OBJECT_NAME: "scmd_ask_info_"+JSON.parse(localStorage.user).info.tenantId,
                whereOf: "",
                operFields: operFields,
                moId: this.objectId,
                page: {
                  pageNumber: 1,
                  pageSize: 0
                },
                orderBy: ""
              }
            ]
          },
          searchOrderViewId: this.viewId,
          searchOrderType: "flow"
        },
        whereOf:"",
        whereOfNum:""
      };
      if (this.$refs["mixForm"]) {
        let whereParam = this.$refs["mixForm"]._makeQuerySql(
          this.$refs["mixForm"].formDatas
        );
        if (whereParam.indexOf("$") != -1) {
          let whereArr = whereParam.split("$");
          params.whereOf = whereArr[0];
          params.whereOfNum = whereArr[1];
        } else {
          params.whereOf = whereParam;
          params.whereOfNum = "";
        }
      }
      // console.log(params);
      this.$http
        .get(envConst.SCMD_API_BASE + "/scmd/askExport/exportAskData", {
          params: params
        })
        .then(response => {
          if (response.data.returnCode === 0) {
            this.orgExModalCancel();
            let message = "操作成功，稍后请去下载中心下载文件";
            if (this.pageTotal === 0) {
              message =
                "操作成功，稍后请去下载中心查询界面下载文件,但导出记录数为0";
            }
            this.$Message.success(message);
          } else {
            this.$Message.error("导出失败");
          }
        });
    },
    handleCheckAllColmus() {
      if (this.indeterminate1) {
        this.checkAllColmus = false;
      } else {
        this.checkAllColmus = !this.checkAllColmus;
      }
      this.indeterminate1 = false;
      if (this.checkAllColmus) {
        this.exportFormData.exportColums = this.exportColumsList.map(item=>{
          return item.fieldCname;
        });
      } else {
        this.exportFormData.exportColums = [];
      }
    },
    checkAllGroupChange(data) {
      if (data.length === this.exportColumsList.length) {
        this.indeterminate1 = false;
        this.checkAllColmus = true;
      } else if (data.length > 0) {
        this.indeterminate1 = true;
        this.checkAllColmus = false;
      } else {
        this.indeterminate1 = false;
        this.checkAllColmus = false;
      }
    },
    initMethod() { },
  },
  components:{
    Detail
  }
};
</script>
<style lang="stylus">
.scmcc-custom-object-handle
  .title
    color #515a6e
    font-size 20px
    line-height 1
    border-left 4px solid #458bf5
    padding-left 9px

  .drawer-content
    display flex
    height 100%

    .left
      flex 0 0 400px

    .right
      flex auto
      border-left 1px solid #ddd
      padding-left 15px

    .process-comments
      .item
        font-size 14px
        padding 15px 0
        border-bottom 1px solid #ddd
</style>
<style scoped lang="stylus">
>>>.DrawerStyle
  .ivu-drawer-body
    position static
    height calc(100% - 95px)

    .cmsc-drawer-footer
      padding-top 0
      background #fff
      display flex
      align-items center
</style>
<style lang="less">
.sccm-list {
  .sccmCallIcon {
    display: none;
  }
  .ivu-table-tbody tr:hover {
    .sccmCallIcon {
      display: inline;
    }
  }
}
</style>
<style scoped >
.scmd-handle-div {
  margin-bottom: 4px;
  background-color: #f1f7f7;
  border-radius: 4px;
  border: none;
}
.icon_1:hover {
  color: #04cbd8;
}
.sccm-page {
  text-align: center;
  margin: 16px 0 10px 0;
}
.btnPos {
  position: fixed;
  bottom: -20px;
  right: 20px;
  width: 480px;
  background-color: #fff;
  border-top: 1px solid #e8e8e8;
  height: 50px;
}

.btnPos button {
  margin-left: 20px;
}
.import-tip {
  width: 460px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(94, 95, 119, 1);
  line-height: 22px;
}
.import-tip-top {
  margin-top: 8px;
  margin-bottom: 24px;
}
.import-tip-top .ivu-icon {
  margin-right: 4px;
}
.import-tip-down a {
  color: #04cbd8;
  cursor: pointer;
}
.import-tip-gray a {
  color: #cdcdcd;
}
.import-title {
  font-family: "PingFangSC-Medium";
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  font-weight: 600;
  color: #33344a;
  margin-bottom: 16px;
}
.import-title-gray {
  color: #cdcdcd;
}
.error-tip {
  height: 18px;
  font-size: 12px;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  color: #e14040;
  line-height: 18px;
}
.success-tip {
  width: 484px;
  height: 66px;
  margin-top: 12px;
  padding-top: 12px;
  padding-left: 12px;
  background: #f7fafa;
  color: #5e5f77;
  font-size: 14px;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  line-height: 22px;
}
.success-tip .ivu-icon {
  margin-right: 4px;
}
.import-model .import-footer {
  width: 600px;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 9;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
.import-model >>> .ivu-form-item-content {
  margin-left: 0 !important;
}
.import-model >>> .ivu-drawer-header {
  padding-left: 36px;
}
.import-model >>> .ivu-drawer-body {
  padding-left: 36px;
  padding-bottom: 54px;
}
.import-model >>> .ivu-form-item {
  margin-bottom: 0px !important;
}
.import-model >>> .import-busType .ivu-form-item-content .ivu-select {
  width: 484px;
}
.import-model >>> .import-busType1 .ivu-form-item-content .ivu-select {
  width: 384px;
  margin-bottom: 16px;
}
.export-model >>> .ivu-form-item-content {
  margin-left: 20px !important;
}
.export-model >>> .ivu-drawer-header {
  padding-left: 36px;
}
.export-model >>> .ivu-drawer-body {
  padding-bottom: 50px;
}
.export-model .export-footer {
  width: 600px;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 9;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
.checkBoxFlex {
  display: flex;
  flex-direction: column;
}
.fileinfo {
  display: inline-block;
  max-width: 100%;
  margin-top: 12px;
  position: relative;
  padding-right: 30px;
}

.btn-delete {
  line-height: 1;
  position: absolute;
  top: -2px;
  right: 0;
  font-size: 20px;
}
.custom-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.custom-upload-list img {
  width: 100%;
  height: 100%;
}
.custom-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.custom-upload-list:hover .custom-upload-list-cover {
  display: block;
}
.custom-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
.temp-icon {
  margin-left: 20px;
}
</style>